"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DeleteOutline_exports = {};
__export(DeleteOutline_exports, {
  default: () => DeleteOutline_default
});
module.exports = __toCommonJS(DeleteOutline_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.32422 7.33984C5.29818 7.13151 5.35026 6.94922 5.48047 6.79297C5.61068 6.6237 5.77995 6.53906 5.98828 6.53906H14.9922C15.2005 6.53906 15.3698 6.6237 15.5 6.79297C15.6302 6.94922 15.6758 7.13151 15.6367 7.33984L13.9375 16.6953C13.8724 17.0208 13.7161 17.2878 13.4688 17.4961C13.2214 17.7044 12.9414 17.8086 12.6289 17.8086H8.37109C8.05859 17.8086 7.77865 17.7044 7.53125 17.4961C7.28385 17.2878 7.1276 17.0208 7.0625 16.6953L5.32422 7.33984ZM6.37891 7.55469L8.05859 16.5195C8.07161 16.5977 8.10417 16.6628 8.15625 16.7148C8.22135 16.7669 8.29297 16.793 8.37109 16.793H12.6289C12.707 16.793 12.7721 16.7669 12.8242 16.7148C12.8893 16.6628 12.9284 16.5977 12.9414 16.5195L14.582 7.55469H6.37891ZM8.50781 2.71094C8.14323 2.71094 7.83073 2.84115 7.57031 3.10156C7.3099 3.36198 7.17969 3.67448 7.17969 4.03906V4.58594H5.32422C5.19401 4.58594 5.07682 4.63802 4.97266 4.74219C4.88151 4.83333 4.83594 4.95052 4.83594 5.09375C4.83594 5.22396 4.88151 5.34115 4.97266 5.44531C5.07682 5.53646 5.19401 5.58203 5.32422 5.58203H15.6758C15.806 5.58203 15.9167 5.53646 16.0078 5.44531C16.112 5.34115 16.1641 5.22396 16.1641 5.09375C16.1641 4.95052 16.112 4.83333 16.0078 4.74219C15.9167 4.63802 15.806 4.58594 15.6758 4.58594H13.8203V4.03906C13.8203 3.67448 13.6901 3.36198 13.4297 3.10156C13.1693 2.84115 12.8568 2.71094 12.4922 2.71094H8.50781ZM8.17578 4.03906C8.17578 3.94792 8.20833 3.86979 8.27344 3.80469C8.33854 3.73958 8.41667 3.70703 8.50781 3.70703H12.4922C12.5833 3.70703 12.6615 3.73958 12.7266 3.80469C12.7917 3.86979 12.8242 3.94792 12.8242 4.03906V4.58594H8.17578V4.03906Z",
      fill: "currentColor"
    }
  )
);
const SvgDeleteOutline = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DeleteOutline_default = SvgDeleteOutline;
